export default "__VITE_ASSET__rfZFwpA7__"